export interface ExcludeCondition {
  shouldExcludeFunction: (value: unknown, gqlObj: {[key: string]: unknown}) => boolean;
  gqlDefaultValue: unknown;
}

export const REST_EXCLUDE_CONDITION_BY_KEY: {[key: string]: ExcludeCondition} = {
  ExcludeIfNullCondition: {shouldExcludeFunction: (value) => value == null, gqlDefaultValue: null},
  'ExecutionSample:ExcludeIfNoAccessCondition': {
    shouldExcludeFunction: (_, gqlObj) =>
      ['bioentity', 'batch', 'container'].every((key) => gqlObj[key] == null),
    gqlDefaultValue: null,
  },
};
